/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'townsquare.townsquare-tags.tag': 'Fjern tag',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, one {Brugt {usageCount,number} sted} other {Brugt {usageCount,number} steder}}',
};
